/* istanbul ignore file */
import { useFieldHelper, LinkField } from 'framework/ui/field';
import { useProjectWeeklyReportsUrl } from 'domain/shared/project';
import { DATE_FORMAT, useDateService } from 'framework/utils';

interface ProjectReportLinkFieldProps {
  source: string;
  sourceDateFrom: string;
  sourceDateTo: string;
  [p: string]: string;
}

const ProjectWeeklyReportLinkField = ({
  source,
  sourceDateFrom,
  sourceDateTo,
  ...props
}: ProjectReportLinkFieldProps) => {
  const { formatDate } = useDateService();
  const { getValue: getId } = useFieldHelper({ source });
  const { getValue: getDateFrom } = useFieldHelper({ source: sourceDateFrom });
  const { getValue: getDateTo } = useFieldHelper({ source: sourceDateTo });
  const { getSingleEntityUrl } = useProjectWeeklyReportsUrl();
  const id = getId();
  const url = getSingleEntityUrl(id);
  const linkText = `${formatDate(getDateFrom(), DATE_FORMAT.FULL_DATE)} - ${formatDate(
    getDateTo(),
    DATE_FORMAT.FULL_DATE,
  )}`;

  return <LinkField {...props} linkText={linkText} value={url} isInternal />;
};

export default ProjectWeeklyReportLinkField;
